import {IReferenciaLink} from "@components/solicitacoes/dto/models/IReferenciaLink.ts";
import {useEffect, useState} from "react";
import {Link, TableCell, TableRow} from "@mui/material";
import {DefaultInfoV1Props} from "@models/DefaultProps.ts";

interface SolicitacaoItemRefInfoRowProps extends DefaultInfoV1Props<IReferenciaLink> {
}

// TODO: implementar
export function SolicitacaoItemRefInfoRow(props: SolicitacaoItemRefInfoRowProps) {
    const [value, setValue] = useState<IReferenciaLink | undefined>()

    useEffect(() => {
        if (typeof props.value == "number") {
            //TODO: implementar
            return;
        }
        if (props.value != null)
            setValue(props.value)

    }, [props.value, props]);

    return (value != null && <TableRow>
        <TableCell>{value.id}</TableCell>
        <TableCell>{value.descricao}</TableCell>
        <TableCell>
            <Link target={'_blank'} href={value.url}>{value.url}</Link>
        </TableCell>
    </TableRow>)
}